import $http from '@/model/utils/http'

const getErrNum = () => $http.get('/org/err/getNum')

const getErrLine = (params) => $http.get('/org/err/getLine', {params})

const getErrUser = (params) => $http.get('/org/err/getList', {params})

  export default {
    getErrNum,
    getErrLine,
    getErrUser
  }